import {GroupingDateInterval} from "./@type";

export const Date_GroupingOptions: Option[] = [
    {
        value   : GroupingDateInterval.DAILY,
        label   : 'Daily'
    },
    {
        value   : GroupingDateInterval.WEEKLY,
        label   : 'Weekly'
    },
    {
        value   : GroupingDateInterval.BIWEEKLY,
        label   : 'Biweekly'
    },
    {
        value   : GroupingDateInterval.MONTHLY,
        label   : 'Monthly'
    },
    {
        value   : GroupingDateInterval.QUARTERLY,
        label   : 'Quarterly'
    },
    {
        value   : GroupingDateInterval.YEARLY,
        label   : 'Yearly'
    },
]